import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ConfigService } from '../services/config.service';
import { debounceTime } from 'rxjs/operators';
import { Login } from '../login/login';


@Injectable({
  providedIn: 'root'
})
export class HistoricoPesquisasMensalService {
  url: string;
  token: any;

  constructor(
    private http: HttpClient,
    private configService: ConfigService
  ) { 
    this.url = configService.getURL() + 'historico-pesquisas-mensal';
    this.token = new Login();
  }

  getHistorico(qtdRegistros){
    return this.http.get<Object[]>(this.url + '?qtdRegistros=' + qtdRegistros, {
        headers: new HttpHeaders({ 'Authorization': 'Bearer ' + this.token.getToken() }) 
      });
  }

  mesAtual(){
    return this.http.get<Object[]>(this.url + '/mes-atual', {
        headers: new HttpHeaders({ 'Authorization': 'Bearer ' + this.token.getToken() }) 
      });
  }
}
